import React from "react";
import Slider from "react-slick";
import styles from "./slick-title.module.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SliderTitle = () => {
  const settings = {
    dots: false,
    vertical: true,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    arrows: false,
  };
  return (
    <Slider {...settings}>
      <div className={styles.slider_title}>
        <h3>Love?</h3>
      </div>
      <div className={styles.slider_title}>
        <h3>Career Growth?</h3>
      </div>
      <div className={styles.slider_title}>
        <h3>Big Win?</h3>
      </div>
    </Slider>
  );
}

export { SliderTitle };